module.exports = __webpack_public_path__ + "static/media/img_prn24.5da2da15.png";